export const ROLES = [
    "WEREWOLF",
    "VILLAGER",
    "SEER",
    "WITCH",
    "HUNTER",
    "GUARD",
];
export const PHASES = [
    "LOBBY",
    "ROLE_REVEAL",
    "NIGHT_GUARD",
    "NIGHT_WOLVES",
    "NIGHT_SEER",
    "NIGHT_WITCH",
    "NIGHT_RESOLUTION",
    "HUNTER_REACTION",
    "MORNING",
    "DISCUSSION",
    "VOTING",
    "VOTE_RESULT",
    "ENDED",
];
//# sourceMappingURL=types.js.map